export var EmbedType;
(function (EmbedType) {
    EmbedType["DESKTOP"] = "DESKTOP";
    EmbedType["MOBILE_WEB"] = "MOBILE WEB";
    EmbedType["HTML5"] = "HTML5";
})(EmbedType || (EmbedType = {}));
